import axios from 'axios';

const REFRESH_TOKEN_URL = '/coreService/moduleCore/auth/refresh-token';

let isLoggingOut = false;
// ---- Shared logout handler ----
const emitLogout = (message = "Your session has expired. Please log in again.") => {
	console.log("logging out", window.location.pathname);
 try {
    // 🧹 clear stored modules
    localStorage.removeItem("app_modules");

    // (optional but recommended)
    // localStorage.removeItem("user");
    // localStorage.removeItem("token");

  } catch (e) {
    console.warn("Failed to clear localStorage:", e);
  }
	if (window.location.pathname !== "/auth-pages/login") {
		const params = new URLSearchParams({
			reason: "logout",
			message,
		});

		window.location.replace(`/auth-pages/login?${params.toString()}`);
	}
};

// ---- Create API instance with shared interceptor ----
const createApiInstance = (baseURL) => {
	const instance = axios.create({
		baseURL,
		withCredentials: true,
	});

	instance.interceptors.response.use(
		(response) => response,
		async (error) => {
			const originalRequest = error.config;

			if (error.response?.status === 401 && !originalRequest._retry) {
				originalRequest._retry = true;

				try {
					// Refresh using the fixed Newback endpoint
					await axios.post(REFRESH_TOKEN_URL, {}, { withCredentials: true });
					return instance(originalRequest);
				} catch (refreshError) {
					emitLogout('Votre session est expirée.');
					return Promise.reject(refreshError);
				}
			}

			return Promise.reject(error);
		},
	);

	return instance;
};

// ---- Cache instances so they’re reused ----
const apiInstances = {};

const apiFor = (service) => {
	if (!apiInstances[service]) {
		apiInstances[service] = createApiInstance(service);
	}
	return apiInstances[service];
};

export default apiFor;
